import script from "./CheckboxForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxForm.vue?vue&type=script&setup=true&lang=ts"

import "./CheckboxForm.vue?vue&type=style&index=0&id=26d18cda&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d18cda"]])

export default __exports__